/* eslint-disable zoomin/scss-import-last */
import 'core-js/es'
// Must precede shadcn.css so the Inter @font-face is in scope.
import '@fontsource-variable/inter'
import '~/client/src/shared/shadcn.css'
import '~/client/src/shared/styles.scss'
import '~/client/src/shared/tailwind.css'
import '~/client/src/shared/tones.scss'
import '~/client/src/shared/vendor.css'
import * as React from 'react'

import * as Sentry from '@sentry/browser'
import { render } from 'react-dom'

import * as e from '~/client/src/shared/stores/EventStore/eventConstants'
import EventContext from '~/client/src/shared/stores/EventStore/EventContext'

import App from '../shared/App'
import AppProvider from '../shared/components/AppProvider'
import Localization from '../shared/localization/LocalizationManager'
import { beforeSend } from '../shared/utils/Sentry'
import ThemeMode from '../shared/utils/ThemeModeManager'
import Container from './container'
import LoginRoutes from './login.routes'
import Config from './LoginConfig'

const eventsToHideInLog = [e.COLLECT_TELEMETRY, e.NO_EFFECT]

function startApp() {
  if (Config.ENVIRONMENT.toLowerCase() !== 'development') {
    Sentry.init({
      beforeSend,
      dsn: 'https://c4509968fb074001bfefc1902752cee6@sentry.io/1819303',
      environment: Config.ENVIRONMENT,
      release: `StruxHub-Login@${Config.VERSION}`,
      attachStacktrace: true,
    })
  }

  Localization.init()

  new App(Config).configure()

  const isTestEnv = ['qa', 'development'].includes(
    Config.ENVIRONMENT.toLowerCase(),
  )
  const container = new Container(isTestEnv)
  const { rootStore } = container
  const { eventsStore } = rootStore

  ThemeMode.init()

  if (isTestEnv) {
    window.stores = rootStore
    window.eventsLog = []

    eventsStore.addPostEventCallback(({ event }: EventContext) => {
      const [type, ...args] = event
      if (eventsToHideInLog.includes(type)) {
        return
      }
      window.eventsLog.push({ type, args })

      console.groupCollapsed(type)

      console.log(...args)

      console.groupEnd()
    })
  }

  function renderUi() {
    render(
      <AppProvider rootStore={rootStore}>
        <LoginRoutes />
      </AppProvider>,
      document.getElementById('app'),
    )
  }

  eventsStore.dispatchN([
    [e.START_ALL, renderUi],
    [e.LISTEN_TO_DEPLOYMENT_VERSION],
  ])
}

Config.READY.then(startApp)
